// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"239dc750","55":"658bb631","173":"4fba05d5","188":"f7306f36","239":"ce722ccf","241":"fc75a519","270":"d9d0fc79","453":"f31200d3","457":"ca98f008","506":"20d8c882","622":"a9ef9a3e","664":"44422fcb","761":"24fc30a4"}[chunkId] + ".chunk.js";
};